import * as React from 'react';
import { isAdmin, isUser, PermissionTypes } from '../ducks/auth';
import { useMiaSelector } from './hooks';

interface IHasPermissionsProps {
  children: React.ReactNode;
  type: PermissionTypes | PermissionTypes[];
  admin?: boolean;
}

let HasPermissions: React.FunctionComponent<IHasPermissionsProps> = ({ children, admin, type }) => {
  const user = useMiaSelector(state => (admin ? isAdmin(state, type) : isUser(state, type)));

  return user ? <>{children}</> : null;
};

HasPermissions = React.memo(HasPermissions);
export { HasPermissions };
